import App from './App';
import "./styles/index.scss"
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import Application from './view/Application';

const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
    },
    {
        path: '/download',
        element: <Application />
    }
]);

ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);